import type { FC } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { Loader } from "@jti/core-components/components/Loader";
import { I18n, useTranslations } from "@jti/ui";

import styles from "./SuccessMessage.module.scss";

type SuccessMessageProps = {
  status: "success" | "pending" | "error";
  email?: string;
};

export const SuccessMessage: FC<SuccessMessageProps> = ({ status, email = "" }) => {
  const { __ } = useTranslations();

  return (
    <div className={styles.container}>
      <h2 className={styles.mainTitle}>{__("cart.order.summary.message.title")}</h2>

      {status === "pending" && <Loader />}

      {status === "success" && (
        <AlertBanner
          tone="success"
          title={__("cart.order.summary.message.subtitle")}
          richDescription={
            <I18n t="cart.order.summary.message.description">
              <strong>{email}</strong>
            </I18n>
          }
        />
      )}
    </div>
  );
};
